import useUpdateReadingHistory from './useUpdateReadingHistory';

export default useUpdateReadingHistory;
